import { useDispatch, useSelector } from 'react-redux';
import React, { useContext, useEffect } from 'react';
import {
    clearSelectedLinesRequestIds,
    setSelectedLinesRequest,
    setSelectedLinesRequestIds,
} from 'app/store/slices/line';
import { Box, Checkbox, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import { FormServiceContext } from 'app/utils/contexts';
import { STATUS_CODES } from 'app/config/status';

export const StripLineSelector = ({ loading }) => {
    const dispatch = useDispatch();
    const { editing, canEdit, errorsList, isInternalForm } = useContext(FormServiceContext);

    const {
        allLines,
        selectedLinesRequest,
        selectedLinesRequestIds: selectedLineIds,
    } = useSelector((state) => state.line);
    const request = useSelector((state) => state.requests.details);

    useEffect(() => {
        if (allLines && allLines.length > 0) {
            const selectedLinesObj = selectedLineIds.map((lineId) => {
                return allLines.find((line) => line.cdLinha === lineId);
            });
            dispatch(setSelectedLinesRequest(selectedLinesObj));
        }
    }, [allLines, dispatch, selectedLineIds]);

    useEffect(() => {
        if (editing) {
            const mapToSelectedIds = selectedLinesRequest.map((line) => line.cdLinha);
            dispatch(setSelectedLinesRequestIds(mapToSelectedIds));
        }
        // eslint-disable-next-line
        return () => {
            dispatch(clearSelectedLinesRequestIds());
        };
        // eslint-disable-next-line
    }, [dispatch]);

    const handleToggle = (selectedId) => {
        const isNotSelectedYet = selectedLineIds.indexOf(selectedId) === -1;

        if (isNotSelectedYet) {
            const alreadSelected = [...selectedLineIds];
            dispatch(setSelectedLinesRequestIds([...alreadSelected, selectedId]));
        } else {
            const filteredList = selectedLineIds.filter((lineId) => lineId !== selectedId);
            dispatch(setSelectedLinesRequestIds(filteredList));
        }
    };

    const color = errorsList.linesRequest ? 'error' : 'inherit';

    const showOnlyLinesFromRequest =
        isInternalForm ||
        request.cdSituacao === STATUS_CODES.APROVADO ||
        request.cdSituacao === STATUS_CODES.CANCELADO ||
        request.cdSituacao === STATUS_CODES.EM_ANALISE ||
        request.cdSituacao === STATUS_CODES.AGUARDANDO_PAGAMENTO ||
        request.cdSituacao === STATUS_CODES.REPROVADO;

    const lineList = showOnlyLinesFromRequest ? selectedLinesRequest : allLines;

    return (
        <>
            <Typography component="h3" style={{ fontSize: '1rem', margin: '24px 0 16px' }} color={color}>
                Selecione a(s) linha(s):
            </Typography>
            <Box width="100%" maxHeight="300px" style={{ overflowY: 'scroll', overflowX: 'hidden' }}>
                <List>
                    {!!lineList.length &&
                        lineList.map((line) => {
                            const labelId = `checkbox-list-label-${line?.cdLinha}`;
                            return (
                                <ListItem
                                    key={line?.cdLinha}
                                    disabled={!canEdit || isInternalForm || loading}
                                    dense
                                    divider
                                    button
                                    disableRipple
                                    onClick={() => handleToggle(line?.cdLinha)}>
                                    <ListItemIcon>
                                        <Checkbox
                                            disabled={!canEdit || isInternalForm || loading}
                                            color="primary"
                                            edge="start"
                                            checked={selectedLineIds.indexOf(line?.cdLinha) !== -1}
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{ 'aria-labelledby': labelId }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText id={labelId} primary={line?.deDescricao} />
                                </ListItem>
                            );
                        })}
                </List>
            </Box>
        </>
    );
};
